// src/pages/CompanyDefaults/companyDefaultsDataConfig.js
// -----------------------------------------------------
// ONE source of truth for every Company‑Defaults field
// (1) Default/blank form data
// (2) Auto‑rendered form sections
// (3) Optional table columns if you need them

// ---------- 1.  Default Values (match your server JSON keys) ----------
export const defaultCompanyDefaultsFormData = {
  companyID: null,
  companyName: "",
  companyType: "",
  companyMotto1: "",
  companyMotto2: "",

  /* Per your JSON */
  website: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  satZipCode: "",
  countryRegion: "",

  phone1: "",
  phoneNumber: null, // your JSON has both phone1 & phoneNumber
  fax: null,
  taxID: "",
  billingClass: null,
  industrialClassification: null,
  registrationNo: null,
  pictureUrl: null,
  iban: null,
  contactName: "",
  eoriNumber: "",
  email: "",
  einNumber: "",
  irsContactNo: "",
  bankName: "",
  bankBranchNo: "",
  bankAccountNo: "",
  paymentRoutingNo: "",
  giroNo: "",
  // You can add cost/wip if you like, though your JSON doesn’t have them:
  costingDate: null,
  wipMaterials: null,

  // If your JSON includes "federalIDNo" or others, put them here
  federalIDNo: "",

  // If your JSON had next* fields, define them too
  // nextInvoiceNumber: "",
  // etc. as needed
};

// ---------- 2.  Sectioned metadata for auto-render ----------

// -- General / Company
export const CompanyDefaultsGeneralInfo = [
  {
    label: "Company ID",
    key: "companyID", // must match JSON "companyID"
    readOnly: true,
  },
  { key: "companyName", label: "Name" },
  { key: "companyType", label: "Type" },
  { key: "companyMotto1", label: "Motto 1" },
  { key: "companyMotto2", label: "Motto 2" },
  { key: "contactName", label: "Contact Name" },
  { key: "phone1", label: "Phone No." },
  { key: "federalIDNo", label: "Federal ID No." },
  { key: "taxID", label: "Tax ID" },
  { key: "eoriNumber", label: "EORI Number" },
  { key: "industrialClassification", label: "Industrial Class." },
  { key: "registrationNo", label: "Registration No." },
  { key: "pictureUrl", label: "Logo / Picture URL" },
  { key: "website", label: "Website" },
];

// -- Address
export const CompanyDefaultsAddressInfo = [
  { key: "address", label: "Address" },
  { key: "address2", label: "Address 2" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zip", label: "ZIP Code" },
  { key: "satZipCode", label: "SAT ZIP Code" },
  { key: "countryRegion", label: "Country/Region" },
];

// -- Communication
export const CompanyDefaultsCommunicationInfo = [
  { key: "email", label: "Email" },
  // If you want to show “phoneNumber” (the server returns null):
  { key: "phoneNumber", label: "Phone Number" },
  { key: "fax", label: "Fax" },
  { key: "einNumber", label: "EIN Number" },
  { key: "irsContactNo", label: "IRS Contact No." },
];

// -- Finance / Payments
export const CompanyDefaultsPaymentsInfo = [
  { key: "bankName", label: "Bank Name" },
  { key: "bankBranchNo", label: "Bank Branch No." },
  { key: "bankAccountNo", label: "Bank Account No." },
  { key: "paymentRoutingNo", label: "Payment Routing No." },
  { key: "giroNo", label: "Giro No." },
  { key: "iban", label: "IBAN" },
  { key: "billingClass", label: "Billing Class" },
  // If your data doesn’t currently include these, they’ll just stay blank:
  { key: "costingDate", label: "Costing Date" },
  { key: "wipMaterials", label: "WIP Materials" },
];

// ---------- 3.  (Optional) Flat list for a table, if needed ----------
export const companyDefaultsFields = [
  { key: "companyID", label: "ID" },
  { key: "companyName", label: "Name" },
  { key: "companyType", label: "Type" },
  { key: "companyMotto1", label: "Motto 1" },
  { key: "companyMotto2", label: "Motto 2" },
  { key: "website", label: "Website" },

  { key: "address", label: "Address" },
  { key: "address2", label: "Address 2" },
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zip", label: "ZIP" },
  { key: "satZipCode", label: "SAT ZIP" },
  { key: "countryRegion", label: "Country/Region" },

  { key: "contactName", label: "Contact" },
  { key: "phone1", label: "Phone 1" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "fax", label: "Fax" },
  { key: "email", label: "Email" },

  { key: "taxID", label: "Tax ID" },
  { key: "federalIDNo", label: "Federal ID" },
  { key: "einNumber", label: "EIN" },
  { key: "irsContactNo", label: "IRS Contact" },
  { key: "eoriNumber", label: "EORI" },
  { key: "industrialClassification", label: "Industrial Class." },
  { key: "registrationNo", label: "Reg. No." },

  { key: "bankName", label: "Bank" },
  { key: "bankBranchNo", label: "Branch No." },
  { key: "bankAccountNo", label: "Account No." },
  { key: "paymentRoutingNo", label: "Routing No." },
  { key: "giroNo", label: "Giro No." },
  { key: "iban", label: "IBAN" },
  { key: "billingClass", label: "Billing Class" },
  { key: "costingDate", label: "Costing Date" },
  { key: "wipMaterials", label: "WIP Materials" },

  // etc. for additional fields/counters if needed.
];
